import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import countries from '../../constants/countries.json';
import FormSelect, { FormSelectProps } from './FormSelect';

type Props<T extends FieldValues, TTransformedValues extends FieldValues | undefined = T> = Omit<
  FormSelectProps<T, TTransformedValues>,
  'options'
>;
const CountrySelect = <T extends FieldValues, TTransformedValues extends FieldValues | undefined = T>(
  props: Props<T, TTransformedValues>
) => {
  const countryOptions = useMemo(() => {
    return countries?.map((country) => ({
      name: country.name,
      id: country.cca2,
    }));
  }, []);

  return <FormSelect label='Country' options={countryOptions ?? []} {...props} />;
};

export default CountrySelect;
